import { render } from "./NewTrainingForm.vue?vue&type=template&id=c4e2b7fc&scoped=true"
import script from "./NewTrainingForm.vue?vue&type=script&lang=js"
export * from "./NewTrainingForm.vue?vue&type=script&lang=js"

import "./NewTrainingForm.vue?vue&type=style&index=0&id=c4e2b7fc&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e2b7fc"]])

export default __exports__